import { useContext, useState } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { BrunoBalkProtocol } from '~/modules/aerobicCapabilities/schema'
import { studentEvaluationDemoContext } from '~/pages/authenticated/personalTrainer/studentEvaluationDemo'

export const BrunoBalk: React.FC = () => {
  const { data } = useContext(studentEvaluationDemoContext)

  const [value] = useState<BrunoBalkProtocol>({
    distance: data?.brunoBalk?.distance ?? 0,
    time: data?.brunoBalk?.time ?? 0,
  })

  return (
    <div className='flex gap-3'>
      <MaskedInput
        mask='float'
        inputMode='numeric'
        value={value.time}
        label='Tempo (min)'
        placeholder='0'
        onChange={() => undefined}
      />

      <MaskedInput
        mask='integer'
        inputMode='numeric'
        value={value.distance}
        label='Distância (m)'
        placeholder='0'
        onChange={() => undefined}
      />
    </div>
  )
}
